import {useState} from 'react'
import {Form} from 'antd'
import http from '@/biz/http.mjs'
import {Modal, useOpenModal} from '@/components/Modal/index.mjs'
import Table from '@/components/Table/Table.jsx'
import runAsync from '@/script/runAsync.mjs'
import SelectBaseline from '@/biz/baseline/SelectBaseline.jsx'

export const canAddNodeToBranch = () => () => {
    return function (nodes) {
        return [...nodes].filter(node => {
            const {bizNodeType, pkid, prjId} = node.data

            return (
                pkid &&
                prjId === this.data.prjId &&
                this.BizNode[bizNodeType]?.classes.includes('product')
            )
        })
    }
}

const FormAddToBranch = ({prjPatternId, ...props}) => {
    return (
        <Form {...props}>
            <Form.Item
                label="目标分支"
                name="branch"
            >
                <SelectBaseline
                    autoSelect={options => options[0]}
                    isDesc="1"
                    pblProgress="1"
                    pblStsCodes="ACTIVE"
                    pblType="INCREMENT"
                    prjPatternId={prjPatternId}
                />
            </Form.Item>
        </Form>
    )
}

const ViewProductType = ({map, value}) => {
    const name = map.BizNode[value].typeName(map)
    return <Table.ViewText value={name} />
}

const ViewProductCode = ({map, value}) => {
    const {bizNodeType} = value
    const {codeProp} = map.BizNode[bizNodeType]
    const code = value[codeProp]
    return <Table.ViewText value={code} />
}

const ViewProductName = ({map, value}) => {
    const {bizNodeType} = value
    const {textProp} = map.BizNode[bizNodeType]
    const text = value[textProp]
    return <Table.ViewText value={text} />
}

const TableProducts = ({map, onChange, ...props}) => {
    const columns = [
        {
            title: '制品类型',
            dataIndex: 'bizNodeType',
            getValue: row => row.bizNodeType,
            component: <ViewProductType map={map} />,
        },

        {
            title: '制品编号',
            dataIndex: 'dpSn',
            component: <Table.ViewText />,
        },

        {
            title: '制品代码',
            dataIndex: 'code',
            getValue: row => row,
            component: <ViewProductCode map={map} />,
        },

        {
            title: '制品名称',
            dataIndex: 'name',
            getValue: row => row,
            component: <ViewProductName map={map} />,
        },

        {
            title: '版本号',
            dataIndex: 'version',
            getValue: row => `${row.sVer}.${row.rev}`,
            component: <Table.ViewText />
        },
    ]

    const rowSelection = {
        defaultSelect: rows => rows.map(e => e.pkid),
        onChange: (_, selectedRows) => onChange(selectedRows),
        type: 'checkbox',
    }

    return (
        <Table
            columns={columns}
            rowKey="pkid"
            rowSelection={rowSelection}
            selectRowOnClick
            {...props}
        />
    )
}

const ModalAddNodeToBranch = ({map, nodes, prjPatternId, onOk, ...props}) => {
    const [params, setParams] = useState({})
    const dataSource = nodes.map(n => n.data)

    const okButtonProps = {
        disabled: ! (params.pkid && 0 < params.pkids?.length)
    }

    const onFormChange = values => {
        const {
            branch: {pblType, pkid, prjId, sVer} = {},
        } = values

        setParams(p => ({...p, pblType, pkid, prjId, sVer}))
    }

    const onTableChange = rows => {
        const pkids = rows.map(e => e.pkid)
        setParams(p => ({...p, pkids}))
    }

    const _onOk = async () => {
        await runAsync(
            () => http.post('/prjbaselines/addIncrementDp', params),
            {action: '加入增量分支'}
        )

        onOk()
    }

    return (
        <Modal
            okButtonProps={okButtonProps}
            title="加入增量分支"
            width={800}
            onOk={_onOk}
            {...props}
        >
            <FormAddToBranch
                prjPatternId={prjPatternId}
                onValuesChange={onFormChange}
            />

            <TableProducts
                map={map}
                dataSource={dataSource}
                onChange={onTableChange}
            />
        </Modal>
    )
}

export const addNodeToBranch = () => () => {
    const openModal = useOpenModal()

    return async function (nodes) {
        const {prjPatternId} = this.data

        await openModal(
            <ModalAddNodeToBranch
                map={this}
                nodes={nodes}
                prjPatternId={prjPatternId}
            />
        )
    }
}
